function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/**
 * Game-specific outbound crypto payment authorization overlay.
 *
 * Listens for: saito-game-crypto-send-auth-open-request
 *
 * If `details.trusted` is true, mycallback is invoked immediately (no UI and
 * no Payment Sent monitor). Otherwise the overlay appears and waits for
 * explicit user authorization; after a successful payment
 * (`saito-crypto-send-confirm` with hash), opens a UI-only
 * SaitoTransactionMonitor hosted on wallet.saitoCrypto. Does not touch the
 * game queue, halted, or restartQueue.
 *
 * This component deliberately has NO close/dismiss/cancel controls.
 * The game remains halted until the player authorizes the payment.
 */

var GameSendAuthTemplate = require('./game-send-auth.template');
var SaitoOverlay = require('./../../saito-overlay/saito-overlay');
function escapeHtml() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
var GameSendAuth = /*#__PURE__*/function () {
  function GameSendAuth(app, mod) {
    var _this = this;
    _classCallCheck(this, GameSendAuth);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, false);
    this.app.connection.on('saito-game-crypto-send-auth-open-request', function (details) {
      _this.handleRequest(details);
    });
  }

  /**
   * First-time / absent preference → checked (opt-in invitation).
   * After the user has saved a value → reflect that stored preference.
   */
  return _createClass(GameSendAuth, [{
    key: "readOutboundCheckboxDefault",
    value: function readOutboundCheckboxDefault() {
      var _this$app$options;
      var pref = (_this$app$options = this.app.options) === null || _this$app$options === void 0 || (_this$app$options = _this$app$options.gameprefs) === null || _this$app$options === void 0 ? void 0 : _this$app$options.crypto_transfers_outbound_trusted;
      if (pref === undefined || pref === null) {
        return true;
      }
      return !!pref;
    }

    /**
     * Lazy-create a single monitor hosted on the SAITO crypto module (not the game).
     */
  }, {
    key: "ensureTransactionMonitor",
    value: function ensureTransactionMonitor() {
      var _this$app$wallet;
      var host = (_this$app$wallet = this.app.wallet) === null || _this$app$wallet === void 0 ? void 0 : _this$app$wallet.saitoCrypto;
      if (!host) {
        console.error('GameSendAuth: wallet.saitoCrypto is not available');
        return null;
      }
      if (!host.transaction_monitor) {
        var SaitoTransactionMonitor = require('../../saito-transaction-monitor/saito-transaction-monitor');
        host.transaction_monitor = new SaitoTransactionMonitor(this.app, host);
      }
      return host.transaction_monitor;
    }

    /**
     * Manual-authorization path only: register one-shot success listener, then
     * invoke the existing payment callback. Payment hash comes from
     * saito-crypto-send-confirm (emitted by the SEND path).
     */
  }, {
    key: "invokePaymentCallback",
    value: function invokePaymentCallback(mycallback) {
      var _this2 = this;
      var onConfirm = function onConfirm(robj) {
        if (robj !== null && robj !== void 0 && robj.err || !(robj !== null && robj !== void 0 && robj.hash)) {
          return;
        }
        try {
          var monitor = _this2.ensureTransactionMonitor();
          if (!monitor) {
            return;
          }
          monitor.render({
            tx: {
              signature: robj.hash
            },
            title: 'Payment Sent',
            lead: 'Waiting for opponent to acknowledge receipt...',
            subtitle: '',
            auto_continue_on_confirm: true,
            callback: function callback() {}
          });
        } catch (err) {
          console.error('GameSendAuth: failed to open transaction monitor', err);
        }
      };
      this.app.connection.once('saito-crypto-send-confirm', onConfirm);
      mycallback();
    }
  }, {
    key: "handleRequest",
    value: function handleRequest(details) {
      if (!(details !== null && details !== void 0 && details.ticker) || !(details !== null && details !== void 0 && details.amount) || !(details !== null && details !== void 0 && details.mycallback)) {
        console.error('GameSendAuth: missing required fields', details);
        return;
      }
      if (details.trusted) {
        details.mycallback();
        return;
      }
      this.render(details);
    }
  }, {
    key: "render",
    value: function render(details) {
      var _this3 = this;
      var publicKey = details.publicKey || details.address || '';
      details.trusted = this.readOutboundCheckboxDefault();
      details.partyName = escapeHtml(this.app.keychain.returnUsername(publicKey));
      details.partyKey = escapeHtml(publicKey);
      this.overlay.show(GameSendAuthTemplate(details));
      this.overlay.blockClose();
      var btn = document.getElementById('game_send_auth_authorize');
      if (btn) {
        btn.onclick = function () {
          var checkbox = document.getElementById('game_send_auth_auto_issue');
          _this3.app.options.gameprefs = _this3.app.options.gameprefs || {};
          _this3.app.options.gameprefs.crypto_transfers_outbound_trusted = checkbox !== null && checkbox !== void 0 && checkbox.checked ? 1 : 0;
          _this3.app.storage.saveOptions();
          _this3.overlay.remove();
          _this3.invokePaymentCallback(details.mycallback);
        };
      }
    }
  }]);
}();
module.exports = GameSendAuth;